module.exports = __webpack_public_path__ + "static/media/Combee_gaussian2.bac086dc.png";